import { DateSelector, InputWithLabel, Toggle } from '../components'
import { SelectDropDownBottomSheet } from '../components/bottomSheetDropDown'
import { SelectDropDown } from '../components/selectDropDown'

export const formComponentMap = {
  text: {
    component: InputWithLabel,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'label',
      code: 'name',
      isRequired: 'isRequired',
      example: 'example',
      isEditable: 'isEditable',
      maxLength: 'maxLength',
      iconLeft: 'iconLeft',
    },
    propValues: {
      type: 'text',
      noIconPadding: true,
    },
  },
  dropDown: {
    component: SelectDropDown,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'label',
      options: 'fieldOptions',
      dropOptions: 'dropOptions',
      code: 'name',
      isEditable: 'isEditable',
      pointerEvents: 'pointerEvents',
      example: 'example',
    },
  },
  selectDropDownBottomSheet: {
    component: SelectDropDownBottomSheet,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'label',
      options: 'fieldOptions',
      dropOptions: 'dropOptions',
      code: 'name',
      isEditable: 'isEditable',
      pointerEvents: 'pointerEvents',
      example: 'example',
    },
  },
  number: {
    component: InputWithLabel,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'label',
      code: 'name',
      isRequired: 'isRequired',
      isEditable: 'isEditable',
      maxLength: 'maxLength',
      example: 'example',
      iconLeft: 'iconLeft',
    },
    propValues: {
      type: 'number',
      keyboardType: 'number-pad',
    },
  },
  toggle: {
    component: Toggle,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      placeholder: 'placeholder',
      label: 'label',
      name: 'name',
      fieldOptions: 'fieldOptions',
      toggleType: 'toggleType',
    },
  },
  date: {
    component: DateSelector,
    formPropMap: {
      onChange: 'onChange',
      onBlur: 'onBlur',
    },
    configPropMap: {
      label: 'label',
      code: 'name',
      isRequired: 'isRequired',
      value: 'value',
      infoMsg: 'infoMsg',
      example: 'example',
    },
  },
}
